import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import {
  LayoutDashboard,
  FileText,
  Users,
  Mail,
  Send,
  LogOut,
  ShieldCheck,
} from "lucide-react";

const items = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true, id: "admin-nav-dashboard" },
  { to: "/admin/articles", label: "Articles", icon: FileText, id: "admin-nav-articles" },
  { to: "/admin/subscribers", label: "Abonnés newsletter", icon: Users, id: "admin-nav-subscribers" },
  { to: "/admin/contacts", label: "Demandes de contact", icon: Mail, id: "admin-nav-contacts" },
  { to: "/admin/newsletter", label: "Envoyer une newsletter", icon: Send, id: "admin-nav-broadcast" },
];

export default function AdminLayout() {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0f172a] text-[#efeade] flex flex-col lg:flex-row font-sans">
      {/* Sidebar */}
      <aside className="lg:w-72 shrink-0 border-b lg:border-b-0 lg:border-r border-[#efeade]/10 bg-[#0a192f]">
        <div className="p-6 lg:p-8">
          <Link to="/admin" className="flex items-center gap-3">
            <span className="w-9 h-9 border border-[#b08d57]/40 flex items-center justify-center text-[#b08d57]">
              <ShieldCheck size={16} strokeWidth={1.5} />
            </span>
            <div>
              <div className="font-serif text-lg">Phénix</div>
              <div className="text-[9px] tracking-[0.28em] uppercase text-[#efeade]/50">
                Back-office
              </div>
            </div>
          </Link>
        </div>
        <nav className="px-3 lg:px-4 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.id}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm tracking-wide transition-colors ${
                  isActive
                    ? "bg-[#b08d57]/20 text-[#f0b74e] border-l-2 border-[#b08d57]"
                    : "text-[#efeade]/70 hover:text-[#efeade] hover:bg-white/5 border-l-2 border-transparent"
                }`
              }
            >
              <it.icon size={16} strokeWidth={1.5} />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-6 mt-8 border-t border-[#efeade]/10">
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#b08d57] mb-2">
            Connecté
          </div>
          <div className="text-sm text-[#efeade]/90 break-all">
            {user?.email}
          </div>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="mt-5 inline-flex items-center gap-2 border border-[#efeade]/25 text-[#efeade]/80 px-4 py-2 text-xs tracking-[0.24em] uppercase hover:bg-[#efeade]/10 transition-colors"
          >
            <LogOut size={14} strokeWidth={1.5} />
            Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 bg-[#0f172a] px-6 lg:px-14 py-10 lg:py-16">
        <Outlet />
      </main>
    </div>
  );
}
